import { STATUS_FIELD } from "modules/swiftboard/components/advance-filter";

// Advanced filter fields shared by the Clients, Admins and Employees tabs,
// which all list tbl_user through /user/get-all. Every key must also be in
// USER_FILTER_FIELDS in the backend's src/api/user/controller.js, the
// whitelist that endpoint filters on. Types are documented in
// modules/swiftboard/components/advance-filter/advance-filter.helpers.js.

export const userFullName = (user) => `${user.first_name || ""} ${user.last_name || ""}`.trim();

export const companyFilterField = {
  key: "company_fid",
  label: "Company",
  type: "select",
  group: "Organization",
  optionsKey: "companies",
  optionLabel: "company_name",
};

export const designationFilterField = {
  key: "designation_fid",
  label: "Designation",
  type: "select",
  group: "Organization",
  optionsKey: "designations",
  optionLabel: "designation_name",
};

export const accountFilterFields = [
  { ...STATUS_FIELD, group: "Account" },
  { key: "is_approved", label: "Approval", type: "boolean", group: "Account", trueLabel: "Approved", falseLabel: "Pending" },
  { key: "is_login_verified", label: "Email Verified", type: "boolean", group: "Account", trueLabel: "Verified", falseLabel: "Pending" },
];

export const activityFilterFields = [
  { key: "last_login_date", label: "Last Login", type: "datetime", group: "Activity", showTime: true },
  { key: "last_active", label: "Last Online", type: "datetime", group: "Activity", showTime: true },
  { key: "updated_date", label: "Last Updated", type: "datetime", group: "Activity" },
  { key: "created_date", label: "Created Date", type: "datetime", group: "Activity" },
];

// The rows of one Promise.allSettled API result; a failed call gives [].
export const settledRows = (result) => (result.status === "fulfilled" ? result.value?.data?.data || [] : []);
